import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

interface Props {
  selected?: boolean
  label: string | undefined
}

const Cell = ({ selected = false, label }: Props) => {
  const isBookkeeperView = useBookkeeperView()
  const textColor = selected ? 'grey000White' : 'grey1000'
  const ref = React.useRef(null)

  if (isBookkeeperView)
    return (
      <OverflowContextProvider childrenRef={ref} value={label}>
        <Text.Normal weight="normal" size="200" color={textColor} innerRef={ref} ellipsis>
          {label}
        </Text.Normal>
      </OverflowContextProvider>
    )

  return <Text.Normal color={textColor}>{label}</Text.Normal>
}

export default Cell
